const navigation = {
  HOME: '主页',
  ABOUT_US: '学会介绍',
  PARTNERS: '合作伙伴',
  MEMBER_SERVICE: '学会服务',
  CPD_TRAINING: 'CPD培训',
  TRAINING_AND_COURSES: '培训与课程',
  EVENT: '学会活动',
  NEWS: '最新动态',
  BECOMING_MEMBER: '成为会员',
  LOGIN_SIGNUP: '登录/注册',
  ONLINE_PAYMENT: '在线支付',
  DOWNLOAD_CENTER: '下载园区',
};

const footer = {
  NAVIGATION: '导航',
  BRANCH: '分会',
  CONTACT_US: '联系我们',
  ADDRESS: '地址',
  PHONE: '电话',
  TELEPHONE: '电话',
  FAX: '传真',
  EMAIL: '邮箱',
  TERMS_AND_CONDITIONS: '条款和协议',
  PRIVACY_POLICY: '隐私政策',
  REFUND_POLICY: '退款政策',
}

const branch = {
  NSW_BRANCH: '新南威尔士分会',
  NSW_BRANCH_ABSTRACT: 'CMASA 的前身是“纽省中医药研究会”，由 13 位旅澳的资深中医专业人士于 1989 年发起成立，创会会长刘太书。刘太书在第二任时因需离澳而由陈通诚代理会长一年有余。杨伊凡为第三、四屆会长。从第三届起更名为：“澳华中医学会” 。在第五届理事会换届时，因财务问题导致分裂成两个学会。一部分仍延用“澳华中医学会”。而以郑建华、曾世宗、韦国庆等为骨干的理事为了杜绝财务监管的漏洞，于 1999 年 3 月决定按联邦公司法将学会注册为有限公众公司，注册名称是 Chinese Medicine & Acupuncture Society of Australia（CMASA），中文名为“澳大利亚中医学会”。郑建华为 CMASA 改名后的第一、二、三届会长；接着曾世宗连任第四、五两届会长；再由韦国庆连任第六至九届会长。',
  NSW_BRANCH_CONTENT: '现在的新南威尔士分会(CMASA-NSW)是由原来的 CMASA 和 ATCMA 两会于 2016 年 5 月合并而成。\n\n  CMASA 的前身是“纽省中医药研究会”，由 13 位旅澳的资深中医专业人士于 1989 年发起成立，创会会长刘太书。刘太书在第二任时因需离澳而由陈通诚代理会长一年有余。杨伊凡为第三、四屆会长。从第三届起更名为：“澳华中医学会” 。在第五届理事会换届时，因财务问题导致分裂成两个学会。一部分仍延用“澳华中医学会”。而以郑建华、曾世宗、韦国庆等为骨干的理事为了杜绝财务监管的漏洞，于 1999 年 3 月决定按联邦公司法将学会注册为有限公众公司，注册名称是 Chinese Medicine & Acupuncture Societyof Australia（CMASA），中文名为“澳大利亚中医学会”。郑建华为 CMASA 改名后的第一、二、三届会长；接着曾世宗连任第四、五两届会长；再由韦国庆连任第六至九届会长。\n\n  在 CMASA 第六届理事会上任后，正值中医准备全国统一注册，学会在韦国庆会长的带领下，积极抗议各种阻碍中医发展以及针对中医师的各种苛刻条件，并努力发展会员，开源节流，学会才有充足的资源和能力来支持学会的运作和争取中医权益的事情，比如跟私人保险公司的沟通谈判等等。在韦国庆担任四届会长期间，学会基本获得了所有私人保险公司的资格认可。这一突破性的贡献，为学会进一步的快速发展和壮大起到了关键的作用。\n\n  从 1989 至 2024 年，CMASA 新南威尔士分会历届会长分别是：刘太书、陈通诚、杨伊凡、郑建华、曾世宗、韦国庆、伍昱、刘建平、王秋冬。\n\n  在 CMASA 的创建和发展历史上，刘太书、陈通诚、郑建华、曾世宗、韦国庆等会长起到了中流砥柱的作用。\n\n  另一个重要中医学会，即澳大利亚全国中医药协会（ATCMA），则更早于 1985 年 6 月由洪海、钟跨凤、叶远超、梁祥、陈愿等 35位华侨老中医们创立，是新南威尔士州第一个华人中医药协会。\n\n  从 1985 年至 2016 年，ATCMA 历任会长分别是：洪海、叶远超、黄焕松、沈铁、贾振龙、陈永发、沈铁、李茂、李景标、萧佳彬、伊万诺夫、关滨、陈曙仪。\n\n  积极推动与其它州的中医学会的联合，是 CMASA 高层领导长期以来矢志不渝的工作，特别是在韦国庆担任 CMASA 总会会长期间取得了非常显著的成效，令学会迅速成为全澳最大的华人中医团体。为了 CMASA 和 ATCMA 两会的联合，在林奇恩医生和王树等老中医们坚韧不拔的推动和撮合下，时任 CMASA 总会会长韦国庆与 ATCMA 会长关滨通过共同举办学术讲座和向政府争取中医权益等活动而相互沟通磨合六年多，在此基础上，当陈曙仪于 2015 年接任 ATCMA 会长后，以宽广的胸怀和果断的决策能力，于 2016 年 5 月毅然与韦国庆会长一起宣布 CMASA 和 ATCMA 合并。两会合并后的英文名称保持为Chinese Medicine & Acupuncture Society of Australia（CMASA），中文名改为“澳大利亚中医药学会”。ATCMA 为合并后的学会增添了四百多名会员和 20 多万澳元。CMASA 与 ATCMA 能够成功合并，韦国庆和陈曙仪两位会长厥功至伟！ ',
  VIC_BRANCH: '维多利亚分会',
  VIC_BRANCH_ABSTRACT: '维多利亚分会的前身是“澳大利亚维省中医针灸学会”，成立于 1981 年，距今 43 年，是澳大利亚最早成立的华人中医团体。澳大利亚维省中医针灸学会历任会长分别是：黃耀恂、黄仑、梁凤芝、张慧文、林子强、宣仁达、王理、王树、田应芳、何佩儒、林成发、吴锦锋、刘成林。\n\n  2008 年，澳大利亚维省中医针灸学会与以悉尼为基地的澳大利亚中医学会 CMASA 联合，成为维多利亚州分会，吴锦锋为首任分会会长；2011 年由刘成林担任分会会长。',
  VIC_BRANCH_CONTENT: '维多利亚分会的前身是“澳大利亚维省中医针灸学会”，成立于 1981 年，距今 43 年，是澳大利亚最早成立的华人中医团体。澳大利亚维省中医针灸学会历任会长分别是：黃耀恂、黄仑、梁凤芝、张慧文、林子强、宣仁达、王理、王树、田应芳、何佩儒、林成发、吴锦锋、刘成林。\n\n  2008 年，澳大利亚维省中医针灸学会与以悉尼为基地的澳大利亚中医学会 CMASA 联合，成为维多利亚州分会，吴锦锋为首任分会会长；2011 年由刘成林担任分会会长。\n\n  2012 年，“澳大利亚中医骨伤专业学会”加盟维多利亚分会。虽尚未到换届选举，但原维多利亚分会的吴锦锋和刘成林两位会长从大局出发，为促成合并成功，主动向 CMASA 总会提出由王文成担任合并后的分会会长。副会长吴锦锋，秘书长陈宝龙，副秘书长兼学术组长刘成林，监事长郭乙隆，副监事长何洪杰，财政曾晓迟，副财政欧阳强，其他理事包括周康、黄贤仪、刘建锋。\n\n  2013 年，在吴锦锋、袁晓雯等医生的游说撮合下，最终获得原上海骨伤研究所副所长、瑞金医院骨伤科主任祝波教授以及荣震烨、金伟明、邢饴赳、倪传智等医生的支持，“澳中中医师协会”加入 CMASA 维州分会。\n\n  从 2008 至 2024 年，维多利亚分会历届会长分别是：吴锦锋、刘成林、王文成、周康、吴锦锋、王文成、李康校。“澳大利亚中医骨伤专业学会”成立于 1995 年，原为 FCMA 的附属分会，会长为王文成，副会长周康，秘书长陈宝龙。于 2012 年加盟 CMASA 维多利亚分会。“澳中中医师协会”由墨尔本商人金凯平于 1988 年成立，主要由来自上海的中医学院本科以上的中医师组成的中医诊所集团，李月秀为时任澳中中医师协会会长，荣震烨是对外联络官。\n\n  2002 年，维省中医针灸学会、澳中中医师协会和黄仑教授所属的澳大利亚专业中医师公会共同组成澳大利亚维州中医联盟（Chinese Medicine Alliance Australia），三方的代表吴锦锋、荣震烨、葛兰英和雷毅，为争取中医的合法权益协同工作了多年。',
  QLD_BRANCH: '昆士兰分会',
  QLD_BRANCH_ABSTRACT: '昆士兰分会于 2004 年 9 月在黄金海岸由总会领导曾世宗、郑建华和韦国庆等主持成立，并由总会委派纽省的赵凤琴为首任会长，秘书长为黄金海岸的张舒翼，财务孙飞柳。当时的昆士兰分会只有三人。随后不断有黄金海岸、布里斯班、图文巴、凯恩斯及阳光海岸等五个城市的会员加入，至 2009 年已有会员 20 多人，经选举由张舒翼接任为第二任会长至 2023 年 12 月，兼任总会副会长和学术部部长。目前会员 560 余人。张舒翼被选为 2024-2025 总会会长，孙飞柳为昆士兰分会会长。',
  QLD_BRANCH_CONTENT: '昆士兰分会于 2004 年 9 月在黄金海岸由总会领导曾世宗、郑建华和韦国庆等主持成立，并由总会委派纽省的赵凤琴为首任会长，秘书长为黄金海岸的张舒翼，财务孙飞柳。当时的昆士兰分会只有三人。随后不断有黄金海岸、布里斯班、图文巴、凯恩斯及阳光海岸等五个城市的会员加入，至 2009 年已有会员 20 多人，经选举由张舒翼接任为第二任会长至 2023 年 12 月，兼任总会副会长和学术部部长。目前会员 560 余人。张舒翼被选为 2024-2025 总会会长，孙飞柳为昆士兰分会会长。\n\n  2013 年昆省分会在总会的指导下参与河南中医药大学的学历生培训计划，为昆省分会培养了 30 余名本科生。2015 又与广州中医药大学合作培训研究生，不断提高昆省会员的专业素质。\n\n  昆省分会在总会的支持下于 2018 年 8 月与世界中医五运六气学会联合会在黄金海岸共同举办了首次世界中医五运六气大会。',
  WA_BRANCH: '西澳分会',
  WA_BRANCH_ABSTRACT: '九十年代初，西澳中医学会成立，并于 1999 年加入 CMASA 成为西澳分会，首任分会会长是林天谱。朱同健于 2013 年接任会长。\n\n  踏入二十一世纪，中医药在澳大利亚越来越普遍，中医师也越来越多。然而，西澳分会的中医宣传和会员发展进展缓慢，多年来会员人数只有二十几人。有鉴于此，总会 CEO 韦国庆博士决定亲自到西澳进行宣传和布局。2016 年 2 月 20 日，CEO 韦国庆博士在西澳举办了一场公开性的高水平中医学术讲座，吸引了几百人参加，加上《澳大利亚时报》的跟踪报道，立即在西澳引起了广泛的关注，影响巨大。当天，韦 CEO 还宣布了澳大利亚中医学会西澳分会成立新一届领导班子：伊丽亚为西澳分会会长，总会副会长；分会理事有赵平、冯海燕、张利伟、江伟民、陆叶。通过这次活动，CMASA在西澳的影响力大增，加上新一届理事会的富有成效的工作，西澳分会会员人数在当年就快速发展到一百多人。',
  WA_BRANCH_CONTENT: '九十年代初，西澳中医学会成立，并于 1999 年加入 CMASA 成为西澳分会，首任分会会长是林天谱。朱同健于 2013 年接任会长。\n\n  踏入二十一世纪，中医药在澳大利亚越来越普遍，中医师也越来越多。然而，西澳分会的中医宣传和会员发展进展缓慢，多年来会员人数只有二十几人。有鉴于此，总会 CEO 韦国庆博士决定亲自到西澳进行宣传和布局。2016 年 2 月 20 日，CEO 韦国庆博士在西澳举办了一场公开性的高水平中医学术讲座，吸引了几百人参加，加上《澳大利亚时报》的跟踪报道，立即在西澳引起了广泛的关注，影响巨大。当天，韦 CEO 还宣布了澳大利亚中医学会西澳分会成立新一届领导班子：伊丽亚为西澳分会会长，总会副会长；分会理事有赵平、冯海燕、张利伟、江伟民、陆叶。通过这次活动，CMASA在西澳的影响力大增，加上新一届理事会的富有成效的工作，西澳分会会员人数在当年就快速发展到一百多人。\n\n  2017 年 5 月，西澳分会召开了第一次全体会员大会。总会会长郑建华博士和 CEO 韦国庆博士到西澳参加了会议，并作了指导性的讲话。在随后的几年时间里，韦 CEO 多次亲临西澳指导工作和举办学术讲座；在疫情前还分次邀请学会德高望重的老会长、老中医到西澳分会做学术讲座，例如陈曙仪会长、曾世宗会长、王树和萧佳彬等名老中医，他们对西澳分会的工作给予很大的帮助和支持。',
  WA_2018_BRANCH_BOARD_DIRECTORS: '2018年西澳分会理事名单',
  WA_2020_BRANCH_BOARD_DIRECTORS: '2020年西澳分会理事名单',
  WA_2022_BRANCH_BOARD_DIRECTORS: '2022年西澳分会理事名单',
  PRESIDENT: '会长',
  VICE_PRESIDENT: '副会长',
  SECRETARY_GENERAL: '秘书长',
  ACADEMIC_COMMITTEE: '学术委员',
  DISCIPLINARY_COMMITTEE_MEMBER: '纪检委员',
  EXTERNAL_LIAISON: '对外联络',
  FINANCE_COMMITTEE_MEMBER: '财务委员',
  CHIEF_SUPERVISOR: '监事长',
  OFFICE_DIRECTOR: '办公室主任',
  SA_BRANCH: '南澳分会',
  SA_BRANCH_ABSTRACT: '  南澳分会成立于 2016 年，由总会 CEO 韦国庆亲自到南澳筹办成立。首任会长是富大力。从 2017 年 7 月至今，顾雄文一直担任南澳分会会长、总会副会长、全国理事会常务理事。李晓宁为分会副会长、全国理事会理事，郑钰为秘书长，李花是学术组长。',
  SA_BRANCH_CONTENT: '  南澳分会成立于 2016 年，由总会 CEO 韦国庆亲自到南澳筹办成立。首任会长是富大力。从 2017 年 7 月至今，顾雄文一直担任南澳分会会长、总会副会长、全国理事会常务理事。李晓宁为分会副会长、全国理事会理事，郑钰为秘书长，李花是学术组长。',
  TAS_BRANCH: '塔斯马尼亚分会',
  TAS_BRANCH_ABSTRACT: 'CMASA 总会计划成立塔斯马尼亚分会的工作始于 2022 年 8 月，由行政总裁韦国庆和时任总会会长周康谋划推行，后因疫情的影响而暂缓。2023 年 11 月 13 日，总会常务理事会一致同意并通过成立塔斯马尼亚分会的决议。2023 年 12 月 9 日塔斯马尼亚分会正式宣告成立。周康暂代塔斯马尼亚分会会长，常务副会长朱秀婷，秘书长魏雯迪。',
  TAS_BRANCH_CONTENT: 'CMASA 总会计划成立塔斯马尼亚分会的工作始于 2022 年 8 月，由行政总裁韦国庆和时任总会会长周康谋划推行，后因疫情的影响而暂缓。2023 年 11 月 13 日，总会常务理事会一致同意并通过成立塔斯马尼亚分会的决议。2023 年 12 月 9 日塔斯马尼亚分会正式宣告成立。周康暂代塔斯马尼亚分会会长，常务副会长朱秀婷，秘书长魏雯迪。',
};

const home = {
  HOME_INTRODUCTION: "澳大利亚中医药学会（Chinese Medicine And Acupuncture Society of  Australia, CMASA）是澳大利亚领先的中医药专业组织，致力于推广中医药文化、提升中医药从业者的专业水平，并为公众提供高质量的中医药健康服务。我们汇聚了众多资深中医师、针灸师、中药师、推拿师及健康专家，共同推动中医药在澳大利亚的规范化、科学化发展。",
  START_IN: '成立已有',
  YEARS: '年',
  NO_MEMBERS: '现有会员',
  PEOPLE: '人',
  AUSTRALIAN_BRANCH: '全澳分会',
  BRANCHES: '个',
  LANG_SUPPORTED: '支持语言',
  LANG: '种',
  CONTACT_COMMUNICATION: '接洽沟通',
  CONTACT_COMMNUNICATION_DESCRIPTION: "争取健保机构对针灸相关服务的合理给付",
  ACADEMIC_DISCUSSION: '学术交流',
  ACADEMIC_DISCUSSION_DESCRIPTION: '学会每年举办四至五次可授予继续教育学分的活动',
  HELP_EACH_OTHER: '互动互助',
  HELP_EACH_OTHER_DESCRIPTION: '为澳洲中医针灸专业人员提供一个互动互助的平台',
  MEDICINE_CULTURE: '展示中医的优势与文化',
  MEDICINE_CULTURE_DESCRIPTION: '引导鼓励会员积极参与社区内外大众健康事物',
  REGISTER_NOW: '立即报名',
  JOIN_US_BANNER: '加入我们，成为澳大利亚中医药学会的一员',
  JOIN_US_BANNER_DESCRIPTION: '无论您是中医药从业者、学生，还是对中医药文化感兴趣的公众，CMASA都欢迎您的加入！',
  JOIN_US_BANNER_LIST_1: '享受专业支持、教育资源及行业网络。',
  JOIN_US_BANNER_LIST_1_BOLD: '成为会员',
  JOIN_US_BANNER_LIST_2: '加入我们的健康讲座、研讨会及社区活动。',
  JOIN_US_BANNER_LIST_2_BOLD: '参与活动',
  JOIN_US_BANNER_LIST_3: '共同推动中医药在澳大利亚的发展与传承。',
  JOIN_US_BANNER_LIST_3_BOLD: '支持我们',
  JOIN_US_BANNER_CTA: '立即加入 CMASA',

  OUR_MISSION: '我们的使命',
  OUR_MISSION_1_TITLE: '传承与创新',
  OUR_MISSION_1_DESCRIPTION: '弘扬中医药千年智慧，结合现代医学科技，推动中医药的国际化发展。',
  OUR_MISSION_2_TITLE: '会员服务',
  OUR_MISSION_2_DESCRIPTION: '为会员提供专业支持、教育资源及行业网络，促进会员个人及专业发展。',
  OUR_MISSION_3_TITLE: '公众健康',
  OUR_MISSION_3_DESCRIPTION: '推广中医药文化，提供专业健康咨询服务，提升公众健康意识。',

  ONLINE_PAYMENT: '在线缴费',
  MEMBER_PAYMENT: '会籍缴费',
  CPD_PAYMENT: '购买CPD',
  TRAINING_COURSE_PAYMENT: '培训课程缴费',
  OTHER_PAYMENT: '其他缴费',

  TRAINING_COURSE: '培训课程',
  HISTORICAL_CPD: '历史CPD',

  WELCOME_TO_CMASA: '欢迎来到澳大利亚中医药学会（CMASA）',
  WELCOME_TO_CMASA_DESCRIPTION: "—— 传承千年智慧，守护健康未来 ——",
}


const aboutUs = {
  ABOUT_US_INTRODUCTION: "澳大利亚中医药学会（Chinese Medicine And Acupuncture Society of  Australia, CMASA）是澳大利亚领先的中医药专业组织，致力于推广中医药文化、提升中医药从业者的专业水平，并为公众提供高质量的中医药健康服务。\n\n我们汇聚了众多资深中医师、针灸师、中药师、推拿师及健康专家，共同推动中医药在澳大利亚的规范化、科学化发展。",
  EVENT_TIMELINE: '大事年表',
  CARD_TITLE_1: "敢为人先，筑基垒台",
  CARD_CONTENT_1: "四十多年前的澳大利亚，中草药店和执业中医师寥若晨星；踏入八十年代后，随着从中国和东南亚来的移民的逐渐增多，中医执业人员也随之增加。然而，当时的中医药状况尚未成行业气候，犹如散兵游勇。澳大利亚中医药学会的先辈们意识到一个行业要发展，没有组织就成不了气候，没有舞台就演不了戏。于是，学会的先辈们在墨尔本和悉尼先后组建起澳大利亚首个中医专业团体，分别是 1981 年在墨尔本成立的“澳大利亚维省中医针灸学会”、1985年在悉尼成立的“澳洲全国中医药协会”和 1989 年成立的“纽省中医药研究会”。不同中医学会相继成立，有其历史原因，也有其历史意义。最根本的目的就是为中医，为后人筑基垒台。",
  CARD_TITLE_2: '道路曲折，艰难前行',
  CARD_CONTENT_2: "1993年\n维省中医针灸学会因内部矛盾，有人带了一批会员脱离维省中医针灸学会，另外成立一个中医学会，令初步兴起的中医组织又陷入力量分散的困境。面对困难，当时的正副会长梁凤芝和宣仁达，以及秘书长邱义旗等奋力挽救学会的损失。后来由王树医师担任会长，加上原 RMIT 中医部主任陈炳忠博士和田应芳硕士夫妇俩进入理事会，树立以学术为主轴，学会又逐步扩大。\n\n\n1998年\n原“澳华中医学会”被迫分为两个学会，郑建华临危受命当选为会长，并于 1999 年将学会正式改名为“澳大利亚中医学会”（CMASA）。郑建华连任两届会长后由曾世宗接任两届会长，然后韦国庆连任四届会长。在 CMASA 的创建和发展历史上，郑建华、曾世宗、韦国庆三位会长做出了不朽的贡献。CMASA 经过十几届会长和全体理事的共同努力，至今已发展成为四千多人的专业学会。",
  CARD_TITLE_3: '会员利益，学会使命',
  CARD_CONTENT_3: "2003年\n03年初，本会会员可享受中医针灸服务GST FREE优惠。\n\n2008年\n澳大利亚的私人医疗保险公司将不再接受中医师或针灸师单独申请为服务提供者，所有中医针灸提供者必须是全国性的中医针灸专业协会的会员，而且该全国性中医针灸协会必须经过保险公司的审核认可。在此情形下，时任CMASA 会长的韦国庆积极与各大私人医疗保险公司联系，并成立以韦国庆、郑建华、罗栩威为主的谈判小组，不断与保险公司沟通，CMASA 最终争取到澳大利亚所有私人医疗保险公司的资质认可。澳大利亚中医骨伤专业学会并入 CMASA 维多利亚分会后，也积极参与学会争取最后一个医疗保险公司 BUPA 的谈判工作，做出了积极的贡献。",
  CARD_TITLE_4: '资源整合，更上层楼',
  CARD_CONTENT_4: "2012年\n为了中医行业在澳大利亚的发展壮大，因应 2012 年全国中医注册，澳大利亚中医学会 CMASA 和澳大利亚全国中医药协会ATCMA 于 2010 年 7 月 2 日在悉尼成立联合联络工作小组，召集人为林奇恩医生。联合联络工作小组统筹两会的学术科研活动及对外教育、交流、合作、媒体等事宜。2012 年 1 月 19日，两会正式宣布成立澳大利亚注册中医联合会。联合会理事会成员包括：林奇恩医生、韦国庆医师（时任 CMASA 总会会长）、关滨医师（时任 ATCMA 会长）、曾世宗医师、陈曙仪医师、伊万诺夫医师。",
  CARD_TITLE_5: 'CMASA的重大里程碑',
  CARD_CONTENT_5: '2015 年陈曙仪当选 ATCMA 会长，在两会多年合作和协商的基础上，陈曙仪当机立断，一锤定音，终于在 2016 年 5 月宣布与 CMASA 合并。合并后的学会英文名称保持为 CMASA，中文改为澳大利亚中医药学会。',
  BRANCH_INTROUCTION: '分会介绍',
  MAGAZINE_EDITOR: '杂志编辑',
  MAGAZINE_EDITOR_DESCRIPTION: "《澳洲中医药》作为南半球首创的中医药学术刊物，由澳大利 亚全国中医药协会 ATCMA 1986 年开始发行，并与中国中医研究院每 年互换杂志。每期年刊除报道澳洲和中国的中医药要闻之外，主要 刊登协会内外学术水准较高的中医专业文章，如论著、研究和探 讨、临床经验、学习心得、病案分享等等。《澳洲中医药》杂志获 澳洲国立图书馆、新南威尔士州立图书馆、悉尼科技大学图书馆收藏。\n\n澳大利亚中医学会 CMASA 自 2000 年始，每年出版一册综合性中 医医学杂志，包括专业学术性较高的《澳大利亚中医药杂志》和科 普性质的《中医与健康》。每次印刷 3000-5000 册，除在澳大利亚 全国发行外，在美国、英国、日本、法国、俄罗斯、香港、马来西 亚也有发行点。办杂志初期因学会无经费，困难重重，需靠理事们 私人岀资维持运作。孙伟华、王树担任过多期的总编、主编，近年 的杂志主编是韦国庆，历届总会会长担任时年社长。学会办中医杂志的目的是为了学术交流与传承，指导临床实践，推广中医药文化和提高学会专业形象。",
  KEY_MEMBERS_CMASA: "澳大利亚中医药学会历届理事会主要成员名录",
  VIEW: '查看',
}

const cpd = {
  NO_CPD_FOUND: '未找到CPD培训课程',
  NO_EVENT_FOUND: '未找到学会活动',
  NO_TRAINING_COURSE_FOUND: '未找到培训课程',
  NO_HISTORICAL_CPD_FOUND: '未找到历史CPD',
  NO_MORE_CPD_FOUND: '未找到更多CPD培训课程',
  COLLAPSE: '收起',
  EXPAND: '展开',
  LOADING: '加载中',
  RECOMMENED: '推荐',
  READ_MORE: '阅读更多',

  NO_EVENTS_FOUND: '未找到学会活动',
  NO_MORE_EVENTS_FOUND: '未找到更多的学会活动',
}

const news = {
  NO_NEWS_FOUND: '未找到学会新闻',
  TOTAL: '总计',
  PAGES: '页'
}

const members = {
  NO_PARTICULAR_ORDER: '所有排名均无特定顺序',
  LIST_OF_HONORS_2024_2025: '2024-2025 荣誉名单',
  LIFETIME_HONORARY_MEMBER: '终身名誉会员',
  LIFETIME_HONORARY_PRESIDENT: '终身名誉会长',
  HONORARY_PRESIDENT: '名誉会长',
  NATIONAL_COUNCIL_MEMBER: '全国理事会',
  STANDING_COMMITTEE: '常务委员会',
  DEPUTY_SUPERVISOR: '副监事长',
  DEPUTY_SECRETARY_GENERAL: '副秘书长',
  SECRETARY_ASSISTANT: '秘书部助理',
  HEAD_OF_ACADEMIC_DEPARTMENT: '学术部部部长',
  ASSISTANT_TO_DIRECTOR_OF_ACADEMIC_DEPARTMENT: '学术部部长助理',
  ACADEMIC_ADVISOR: '学术顾问',
  CMASA_NATIONAL_COUNCIL: 'CMASA全国理事会',
};

const memberService = {
  CONTACT_COMMNUNICATION_DETAIL_DESCRIPTION: "CMASA致力于促进对传统医学实践的公平获取，重点推动针灸服务的公平保险覆盖。作为CMASA倡导工作的核心部分，我们与医疗提供者和保险公司密切合作，提高对针灸的益处和成本效益的认识。通过与保险行业领袖和监管机构进行积极对话，CMASA寻求确保针灸服务在标准医疗政策中得到认可。我们的目标是填补保险覆盖的缺口，使患者能够更大程度地获得安全、有效和经济实惠的针灸治疗，作为其整体健康选择的一部分。",
  ACADEMIC_DISCUSSION_DETAIL_DESCRIPTION: "作为CMASA推进针灸和传统医学知识的承诺的一部分，协会每年组织四到五次教育活动。这些高质量的继续教育机会允许会员在参与深入讨论、专家主讲的演讲和合作研讨会时赚取学分。主题从针灸技术的最新研究到综合医疗和以患者为中心的护理的发展不等。\n\n这些聚会营造了一个促进临床能力和持续专业成长的学术环境，并促进跨学科的交流。通过为从业者提供必要的知识和工具，CMASA确保其会员在该领域保持领先，为患者提供最高质量的护理。",
  HELP_EACH_OTHER_DETAIL_DESCRIPTION: "CMASA致力于为澳大利亚的针灸专业人士创建一个互动和支持的平台。我们培养一个合作社区，鼓励从业者通过在线论坛、网络活动和指导计划分享知识、经验和最佳实践。\n\n我们的倡议促进开放的沟通和相互支持，使从业者能够应对挑战、庆祝成功，并交流关于针灸最新趋势和技术的见解。我们相信，一个强大的专业网络能够提升患者护理，并有助于针灸社区在澳大利亚的发展。团结一致，我们可以增强我们的职业，倡导共同利益，并向更广泛的公众宣传针灸的好处。",
  MEDICINE_CULTURE_DETAIL_DESCRIPTION: "CMASA自豪地强调传统中医（TCM）的丰富遗产和优势，通过针灸、草药和气功等实践提供整体健康方法。我们鼓励我们的会员积极参与社区健康倡议，参加外展项目和研讨会，提高公众对中医益处的认识。这种参与不仅增强了社区联系，还展示了针灸专业人士对公共健康的关键贡献。共同努力，我们可以倡导整体健康，并加强中医在更广泛的医疗保健领域的重要性。",
};

const partners = {
  INSURANCE_HOUSE_HOME_PAGE: "Insurance House 网站主页",
  INSURANCE_HOUSE_PII_URL: "专属CMASA 会员购买PII链接",

  CMASA_MEMBER_EXCLUSIVE_OFFER: "CMASA 会员专属保险方案",

  EXCLUSIVE_QUOTES_TITLE: "CMASA 会员专属专业责任保险报价",
  EXCLUSIVE_QUOTES_DESCRIPTION: '📌 为会员提供的 "专业责任保险（PII）" 专属报价服务，适用于各类专业人士，保障您的职业风险。申请流程快捷，专属优惠助您安心执业。',
  EXCLUSIVE_QUOTES_CTA: "点击获取专业责任保险报价",

  CONTENT_AND_GLASS_TITLE: "CMASA 会员专属诊所、企业及店铺财产和玻璃保障",
  CONTENT_AND_GLASS_DESCRIPTION: "📌 专为 CMASA 会员设计的财产与玻璃保险方案。",
  CONTENT_AND_GLASS_CTA: "了解财产及玻璃保障详情",
  
  GET_QUOTE_TUTORIAL_TITLE: "获取报价的视频教程",
  GET_QUOTE_TUTORIAL_DESCRIPTION: "📌 此页面内包含一段简短视频，逐步演示 CMASA 会员如何在线获取专业责任保险的报价。适合首次申请者或希望了解流程的会员查看。",
  GET_QUOTE_TUTORIAL_CTA: "观看视频教程并获取报价",

  INSURANCE_COM_HOME_PAGE: "insurance.com.au 官网主页",
  INSURANCE_COM_DESCRIPTION: "这是 insurance.com.au 的官方网站主页，提供各种商业保险服务与产品介绍。",
  INSURANCE_COM_CTA: "访问 insurance.com.au 官网",
}

const ourService = {
  OUR_SERVICE_PROFESSIONAL_MEMBER_SERVICE: '专业会员服务',
  OUR_SERVICE_PROFESSIONAL_MEMBER_SERVICE_DESCRIPTION: 'CMASA为中医药从业者提供全面的会员服务，包括：',
  OUR_SERVICE_PROFESSIONAL_MEMBER_SERVICE_LIST_1: '持续教育与培训机会',
  OUR_SERVICE_PROFESSIONAL_MEMBER_SERVICE_LIST_2: '行业最新政策与法规解读',
  OUR_SERVICE_PROFESSIONAL_MEMBER_SERVICE_LIST_3: '专业认证与资格支持',
  OUR_SERVICE_PROFESSIONAL_MEMBER_SERVICE_LIST_4: '行业交流与合作平台',

  OUR_SERVICE_PUBLIC_HEALTH_SERVICE: '公众健康服务',
  OUR_SERVICE_PUBLIC_HEALTH_SERVICE_DESCRIPTION: '我们为公众提供：',
  OUR_SERVICE_PUBLIC_HEALTH_SERVICE_LIST_1: '专业中医健康咨询',
  OUR_SERVICE_PUBLIC_HEALTH_SERVICE_LIST_2: '针灸、推拿、中药治疗服务',
  OUR_SERVICE_PUBLIC_HEALTH_SERVICE_LIST_3: '健康讲座与养生工作坊',
  OUR_SERVICE_PUBLIC_HEALTH_SERVICE_LIST_4: '中医药文化推广活动',

  OUR_SERVICE_MEDICINE_CULTURE: '行业支持与 advocacy',
  OUR_SERVICE_MEDICINE_CULTURE_DESCRIPTION: 'CMASA积极与政府、医疗机构及国际组织合作，推动中医药在澳大利亚的合法化与规范化发展，为行业争取更多支持与认可。',
}

const downloads = {
  LOADING_DOWNLOAD_CATEGORIES: '加载下载内容...',
  DOWNLOAD_CENTER_DESCRIPTION: '欢迎来到我们的下载中心！在这里，您可以获取重要文件，包括会员申请表和关于我们组织的重要信息。',
  DOWNLOAD_CENTER_DESCRIPTION_2: '请浏览以下资源并下载您需要的文件。如有任何疑问，请随时联系我们！',
  DOWNLOADING_FILE: '正在下载文件...',
}

export default {
  translation: {
    ...navigation,
    ...ourService,
    ...footer,
    ...branch,
    ...home,
    ...aboutUs,
    ...cpd,
    ...news,
    ...members,
    ...memberService,
    ...partners,
    ...downloads,
    BACK: '返回',
    ONLINE_ZOOM_MEETING: '网络会议',
    CN: '中',
    EN: '英',
    OTHER_LANGUAGE_VERSION: 'English Version',
    KEY_MEMBERS: '主要成员',
    INTRODUCTION: '介绍',
    LOAD_MORE: '加载更多',
    CURRENT: '当前',
    HISTORY_EVENT: '过往活动',
    HISTORY_CPD: '过往CPD',
    EXPIRED: '已过期',
    MONTH_FORMAT: 'M月',
  }
};
